export const SET_SELECTED_COMPONENT_REPOSITORY = 'component-repository/component-repositories/set-selected-component-repository';
export const SET_COMPONENT_REPOSITORIES = 'component-repository/component-repositories/set-component-repositories';
export const REMOVE_COMPONENT_REPOSITORY = 'component-repository/component-repositories/remove-marketplace';
